import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUtilitiesState } from './utilities';

const utilitiesStateSelector =
  createFeatureSelector<IUtilitiesState>('utilities');

export const selectGestioneUtenze = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseGestioneUtenze
);

export const selectCreazioneUtenza = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseCreazioneUtenza
);
export const selectResponseReteTerzaList = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseReteTerzaList
);
export const selectResponseCercaPerStrutturaRecapito = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseCercaRecapito
);

export const selectResponseUtilityLdv = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseUtilityLdv
);

export const selectResponseDocumentoLdv = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseDocumentoLdv
);

export const selectListaReteTerze = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseListaReteTerze
);

export const selectResponseCompensiRete = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseCompensiRete
);

export const selectResponseCompensiRetePost = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseCompensiRetePost
);

export const selectResponseConfigurazioneBoxless = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseConfigurazioneBoxless
);

export const selectResponseConfigurazioneBoxlessPost = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseConfigurazioneBoxlessPost
);

export const selectResponseFrazionarioList = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseNearlistUffPostale
);

export const selectResponseFrazionarioXls = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseNearlistXls
);
export const selectResponseGo = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseGo
);

export const selectResponseRamGo = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseRamGo
);

export const selectResponseCdGo = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseCdGo
);

export const selectResponseFraz = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseFraz
);

export const selectResponseRecapito = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseRecapito
);

export const selectResponseListaCatalogoMateriale = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseListaCatalogoMateriale
);

export const selectResponseListaCluster = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseListaCluster
);

export const selectResponseConfigurazioneApprovvigionamento = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseConfigurazioneApprovvigionamento
);

export const selectResponseRegoleOrdine = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseRegoleOrdine
);

export const selectResponseStoricoOrdini = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseStoricoOrdini
);

export const selectResponseStoricoOrdiniProfili = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseStoricoOrdiniProfili
);

export const selectResponseStoricoOrdiniPartner = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseStoricoOrdiniPartner
);

export const selectResponseCreazioneOrdine = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseCreazioneOrdine
);

export const selectResponseListFrazionario = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responseListFrazionario
);

export const selectResponsePinRecovery = createSelector(
  utilitiesStateSelector,
  (state: IUtilitiesState) => state.responsePinRecovery
)


